import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { AiOutlineFileAdd } from 'react-icons/ai'
import { /* FiUpload, */FiDownload } from 'react-icons/fi'

import { saleProductAction } from '../../actions'
import { saleProductSelector } from '../../selectors'

import { Button } from '../../components/buttons'
import { SearchBar } from '../../components/search-bar'

export const ActionBar = ({ handleClickCreate }) => {
  const access_token = localStorage.getItem('access_token')
  const dispatch = useDispatch()
  const exportUrl = useSelector(saleProductSelector.getExportedSaleProduct)

  useEffect(() => {
    if (exportUrl) {
      window.open(exportUrl, '_blank')
      dispatch(saleProductAction.resetExportedSaleProduct())
    }
  }, [exportUrl])


  const handleSearch = () => {
    const keywordSearch = document.getElementById('keywordSearch')
    dispatch(saleProductAction.setKeywordSearch({ keywordSearch: keywordSearch.value }))
  }

  const handleClickExport = () => {
    dispatch(saleProductAction.exportSaleProduct(access_token))
  }

  return (
    <Root>
      <SearchBar handleSearch={ handleSearch } />
      <Wrapper>
        <ButtonGroup>
          {/* <Button
            bold
            theme='#428BCA'
            icon={ <FiUpload style={ { fontSize: 16 } } /> }
            width='82px'
            height='26px'
          >
            Import
          </Button> */}
          <Button
            theme='#428BCA'
            icon={ <FiDownload style={ { fontSize: 16 } } /> }
            width='82px'
            height='26px'
            onClick={ handleClickExport }
          >
            Export
          </Button>
        </ButtonGroup>
        <Button
          theme='#D44B49'
          icon={ <AiOutlineFileAdd style={ { fontSize: 16 } } /> }
          width='82px'
          height='26px'
          onClick={ handleClickCreate }
        >
          Create
        </Button>
      </Wrapper>
    </Root>
  )
}


const Root = styled.div`
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    padding: 0 24px;
    margin-bottom: 12px;
`

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
`

const ButtonGroup = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    div:nth-child(1) {
      margin-left: 18px;
      margin-right: 12px;
    }
`



// WEBPACK FOOTER //
// ./src/components/sale-product/action-bar.js